module.exports = __webpack_public_path__ + "static/media/bianzu4.d6e18d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bianzu4.png
// module id = 2156
// module chunks = 0